<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!--
				<el-col :span="3">
					<search-input
						:label="getMessage_('QWCC000904')"
						paramKey="varId"
					/>
				</el-col>-->

				<el-col :span="3">
					<sf-group-wrapper :label="getMessage_('QWCC000920')">
						<el-date-picker v-model="searchDate" @change="changeSearchDate" type="date" style="height: 38px" />
					</sf-group-wrapper>
				</el-col>

				<el-col :span="3">
					<search-input :label="getMessage_('QWCC000905')" paramKey="varVal" />
					<!--변수값-->
				</el-col>
				<el-col :span="3">
					<useYn-select />
					<!--<useYn-select @reload="searchList()" />-->
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/comm/qmsbase/Variable/store/helpers';
import SearchInput from './SearchInput.vue';
import UseYnSelect from './UseYnSelect.vue';
import qmsUtils from '@/store/qms/api';
export default {
	props: {
		scrId: { type: String, default: '' }
	},

	data() {
		return {
			searchDate: ''
		};
	},
	components: { SearchInput, UseYnSelect },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList() {
			this.$sf_toggleLoading(true);
			this.getVariableManagements_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchDate(data) {
			//console.log(' 초기값 data ', data);
			let from, to;
			if (data) {
				from = this.$moment(data).format('YYYY-MM-DD');
				from = from.replace(/\-/g, ''); //-대쉬제거
			} else {
				from = '';
			}
			this.selectDate({ from });
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' });

			let list = [];

			this.useYnList.forEach(row => {
				list.push({
					label: row.commCdName,
					value: row.commCd
				});
			});

			this.setState_({ key: 'gridUseYnList', value: list });
			//console.log('getStartDt_', this.getStartDt_);

			this.searchDate = this.$moment(this.getStartDt_).format('YYYY-MM-DD');

			//변수관리
			//let varValue = await qmsUtils.getVariableValue('test');
			//협력사여부
			//let partNer = await qmsUtils.getPartner();

			//변수관리
			//console.log('varList 가나다라마바사요>>>>>>>>>>>', varValue.varVal);

			//협력사여부
			//console.log('partNer 협력사 여부>>>>>>>>>>>', partNer.partnerYn);

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
